/* 通用接口 */

import axios from 'axios';
import qs from 'qs';

export default {
  getIndexInfo () { // 获取首页信息，包括页头页脚用到的公司信息和首页的热门产品数据
    return axios.get('/cmsform/site/cmssitemenucontent/getMdIndexConfig.ht');
  },

  saveUploadFile (params) { // 保存上传文件
    return axios.post('/mobile/crmCustomerAttachInfoController/saveCustomerFileList.ht', qs.stringify({
      customFileArray: JSON.stringify(params.files)
    }), {
      headers: {
        tokenId: params.token
      }
    });
  },

  getFileUploadList (params) { // 获取文件上传列表
    return axios.get('/mobile/crmCustomerAttachInfoController/queryAttachListMd.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        frontApplyId: params.frontApplyId
      }
    });
  },

  signAgreement (params) { // 电子合同客户签名接口
    return axios.get('/mobile/item/shortcutSignature/pdfSignatureCustomer.ht', {
      params: {
        loanItemApplyId: params.itemApplyId,
        id: Math.random()
      }
    });
  },

  getAboutUsInfo () { // 获取关于我们页面信息
    return axios.get('/loan/backstage/tsettings/getAboutUsInformation.ht');
  },

  getEnableCreditQuotaSwitch () { // 是否启用额度开关接口
    return axios.get('/crmform/customer/userCredit/userCreditQuotaController/isEnableCreditQuotaSwitch.ht');
  },

  generateRSAPublicKey () { // 获取加密公钥
    return axios.get('/agent/generateRSAPublicKey.ht');
  },

  getSysSetting (params) { // 查询系统设置
    return axios.get('/loan/backstage/tsettings/getSetting.ht', {
      headers: {
        tokenId: localStorage.getItem('dl_tokenId_bl')
      },
      params
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/common.js